export default __webpack_public_path__ + "static/media/ufba.4e4f2768.png";